export default __webpack_public_path__ + "static/media/streaks 1.a6354843.svg";